<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_intro')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}


</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.planet.intro.niceToMeet') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.intro.planetsGiveUs') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.intro.showYouHow') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.planet.intro.clickPlanetsDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.planet.intro.clickPlanetsMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        {{ t('tutorial.planet.intro.gotoPlanets') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.planet.intro.imThere') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>